import React from "react";
import { CheckCircle2, Truck, Headphones, ShieldCheck } from "lucide-react";

const features = [
  {
    icon: Truck,
    title: "Consegne rapide",
    desc: "Spedizioni in 24/48h su tutto il territorio nazionale.",
  },
  {
    icon: ShieldCheck,
    title: "Qualità garantita",
    desc: "Prodotti certificati e conformi alle normative vigenti.",
  },
  {
    icon: Headphones,
    title: "Assistenza dedicata",
    desc: "Team commerciale e tecnico al tuo fianco ogni giorno.",
  },
  {
    icon: CheckCircle2,
    title: "Solo per professionisti",
    desc: "Listini personalizzati per rivenditori e imprese.",
  },
];

const FeatureStrip = () => (
  <section className="bg-white border-b border-gray-100">
    <div className="max-w-[1400px] mx-auto px-6 py-8 grid grid-cols-2 lg:grid-cols-4 gap-5">
      {features.map((f) => (
        <div key={f.title} className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-xl bg-[#00A859]/10 flex items-center justify-center shrink-0">
            <f.icon className="w-5 h-5 text-[#00A859]" />
          </div>
          <div>
            <div className="font-bold text-[#0B2545] text-sm mb-0.5">{f.title}</div>
            <div className="text-xs text-gray-600 leading-relaxed">{f.desc}</div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default FeatureStrip;
